export class CSVParseError extends Error {
    constructor(content, csvErrors) {
        super(`Cannot parse content as CSV. ${csvErrors
            .map((error) => error.message)
            .join(', ')}`);
        this.csvErrors = csvErrors;
    }
}
